// src/pages/AdminEditCompanyPage.js
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc, updateDoc, writeBatch, serverTimestamp } from 'firebase/firestore';
import { nanoid } from 'nanoid';

const AdminEditCompanyPage = () => {
    const { userId } = useParams(); // This is the user ID of the company owner
    const navigate = useNavigate();
    const [companyUser, setCompanyUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [slots, setSlots] = useState(0);

    const fetchCompanyUser = useCallback(async () => {
        setLoading(true);
        const userDocRef = doc(db, 'users', userId);
        const docSnap = await getDoc(userDocRef);
        if (docSnap.exists()) {
            const userData = docSnap.data();
            setCompanyUser(userData);
            setSlots(userData.carSlots || 0);
        } else {
            // Handle case where user is not found
        }
        setLoading(false);
    }, [userId]);

    useEffect(() => {
        fetchCompanyUser();
    }, [fetchCompanyUser]);

    const handleSave = async () => {
        const userDocRef = doc(db, 'users', userId);
        const currentSlots = companyUser.carSlots || 0;
        const newSlots = Number(slots);

        if (newSlots < currentSlots) {
            if (!window.confirm("Araç limitini düşürmek mevcut QR kodlarını silmez. Devam etmek istiyor musunuz?")) {
                return;
            }
            await updateDoc(userDocRef, { carSlots: newSlots });
        } else if (newSlots > currentSlots) {
            const slotsToAdd = newSlots - currentSlots;
            if (!window.confirm(`${slotsToAdd} adet yeni araç slotu ve QR kodu oluşturulacak. Onaylıyor musunuz?`)) {
                return;
            }
            const batch = writeBatch(db);
            // Update the user's slot count
            batch.update(userDocRef, { carSlots: newSlots });
            // Create new QR codes and vehicle profiles
            for (let i = 0; i < slotsToAdd; i++) {
                const qrId = `RC-${nanoid(6).toUpperCase()}`;
                const qrDocRef = doc(db, 'qrCodes', qrId);
                const profileDocRef = doc(db, 'vehicleProfiles', qrId);

                batch.set(qrDocRef, { code: qrId, isLinked: true, linkedUserId: userId, companyId: companyUser.companyProfileId, createdAt: serverTimestamp() });
                batch.set(profileDocRef, { userId: userId, companyId: companyUser.companyProfileId, companyName: companyUser.displayName, vehiclePlate: '', isRented: false, internalData: {}, createdAt: serverTimestamp() });
            }
            await batch.commit();
        }
        
        alert('Şirket güncellendi!');
        navigate('/admin/companies');
    };

    if (loading) return <div>Yükleniyor...</div>;
    if (!companyUser) return <div>Şirket bulunamadı.</div>;

    return (
        <div className="container mx-auto p-8 max-w-lg">
            <h1 className="text-2xl font-bold mb-4">Şirketi Düzenle</h1>
            <div className="bg-white p-6 rounded-lg shadow-md space-y-4">
                <p><strong>Şirket Adı:</strong> {companyUser.displayName}</p>
                <p><strong>Email:</strong> {companyUser.email}</p>
                <div>
                    <label className="block font-medium">Araç Limiti:</label>
                    <input
                        type="number"
                        value={slots}
                        onChange={(e) => setSlots(e.target.value)}
                        className="w-full border p-2 rounded"
                        min="0"
                    />
                     <p className="text-xs text-gray-500 mt-1">Limiti artırmak otomatik olarak yeni QR kodları oluşturur.</p>
                </div>
                <button onClick={handleSave} className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">Değişiklikleri Kaydet</button>
            </div>
        </div>
    );
};

export default AdminEditCompanyPage;